interface AudioRecognitionBridgeActivity {
  pathname?: string;
  lessonPlaying: boolean;
  repertoirePlaying: boolean;
  documentVisible: boolean;
}

const matchesRoute = (pathname: string, route: string) =>
  pathname === route || pathname.startsWith(`${route}/`);

export const shouldRunAudioRecognitionBridge = ({
  pathname = '',
  lessonPlaying,
  repertoirePlaying,
  documentVisible,
}: AudioRecognitionBridgeActivity) => {
  if (!documentVisible) return false;

  const normalizedPath = pathname.replace(/\/$/, '');
  if (matchesRoute(normalizedPath, '/tutorial')) return true;
  if (matchesRoute(normalizedPath, '/lesson')) return lessonPlaying;
  if (matchesRoute(normalizedPath, '/repertoire-play')) return repertoirePlaying;

  return false;
};
